import React from 'react';
import { useIntl } from 'react-intl';

const DetailedFields: React.FC<{ label: string; value: string; dataTestId: string; showColon?: boolean }> = ({
    label,
    value,
    dataTestId,
    showColon = false,
}) => {
    const intl = useIntl();

    return (
        <div className={'grid-row margin-y-105'}>
            {showColon ? (
                <div className={'grid-col-12'}>
                    <span className={'data_labels'}>{intl.formatMessage({ id: label })}:</span>
                    <span className={'padding-left-1'} data-testid={dataTestId}>
                        {value}
                    </span>
                </div>
            ) : (
                <>
                    <div className={'grid-col-6'}>
                        <span className={'data_labels'}>{intl.formatMessage({ id: label })}</span>
                    </div>
                    <div className={'grid-offset-1 grid-col-5'}>
                        <span data-testid={dataTestId}>{value}</span>
                    </div>
                </>
            )}
        </div>
    );
};

export default DetailedFields;
